import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  padding: (p) => p.spacing(1.5),
  gap: (p) => p.spacing(1),
};

export const chip: SxStyle = {
  background: (p) => p.palette.primary[50],
  fontSize: (p) => p.typography.caption.fontSize,
  p: 0.5,
  borderRadius: (p) => p.spacing(0.5),
  color: (p) => p.palette.primary[500],
  height: (p) => p.spacing(3),
  cursor: 'default',
  '&:hover': {
    background: (p) => p.palette.primary[50],
  },
};
